module.exports = __webpack_public_path__ + "img/nr.c403b3e9.svg";